import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "./locales/en.json";
import plTranslations from "./locales/pl.json";
import esTranslations from "./locales/es.json";
import deTranslations from "./locales/de.json";
import frTranslations from "./locales/fr.json";
import ruTranslations from "./locales/ru.json";

export const SUPPORTED_LANGUAGES = ["en", "pl", "es", "de", "fr", "ru"];
export const DEFAULT_LANGUAGE = "en";

// Get initial language from URL subfolder if present, or localStorage, or default 'en'
const getInitialLanguage = () => {
  const path = window.location.pathname;
  const segments = path.split("/").filter(Boolean);

  // Check if any URL segment is a supported language
  for (const seg of segments) {
    if (SUPPORTED_LANGUAGES.includes(seg)) {
      return seg;
    }
  }

  const savedLang = localStorage.getItem("i18nextLng");
  if (savedLang && SUPPORTED_LANGUAGES.includes(savedLang)) {
    return savedLang;
  }

  return DEFAULT_LANGUAGE;
};

const initialLang = getInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      pl: { translation: plTranslations },
      es: { translation: esTranslations },
      fr: { translation: frTranslations },
      de: { translation: deTranslations },
      ru: { translation: ruTranslations },
    },
    lng: initialLang,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false, // React handles XSS escaping
    },
  });

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("i18nextLng", lng);
});

export default i18n;
